import { ContextOutOfBoundsError } from "providers/ContextOutOfBoundsError";
import { createContext, ReactNode, useContext } from "react";
import { usePageProjectData } from "./usePageProjectData";

type ProjectData = NonNullable<ReturnType<typeof usePageProjectData>["data"]>;
type ProjectDataContextValue = ProjectData & {
  resetDataTableProviderKey: () => void;
};

const ProjectDataContext = createContext<ProjectDataContextValue | undefined>(
  undefined,
);

interface ProjectDataProviderProps extends ProjectData {
  children: ReactNode;
  resetDataTableProviderKey: () => void;
}

export const ProjectDataProvider = ({
  children,
  analysisTableGroups,
  analysisResultsByTableId,
  datasets,
  project,
  resetDataTableProviderKey,
}: ProjectDataProviderProps) => {
  return (
    <ProjectDataContext.Provider
      value={{
        analysisTableGroups,
        analysisResultsByTableId,
        project,
        datasets,
        resetDataTableProviderKey,
      }}
    >
      {children}
    </ProjectDataContext.Provider>
  );
};

export const useProjectDataContext = () => {
  const value = useContext(ProjectDataContext);

  if (value === undefined) {
    throw new ContextOutOfBoundsError("ProjectDataContext");
  }

  return value;
};
